/**
 * Перевод Uint байт в Hex
 * @param numbers - массив байтов
 */
export const toHexString = (numbers: Uint8Array) => {
  return Array.from(numbers, (number) =>
    number.toString(16).padStart(2, '0'),
  ).join('')
}
